import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';

import { UploadCategoryStateContext } from '.';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		categoryStatus: null,
		categoryPreviousStatus: null,
		isCategoryStateFetching: false,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				categoryStatus: response.data,
			});
		}
	}

	handleRefetch = forceChildrenUpdate => {
		this.setState({ isCategoryStateFetching: true });
		if (forceChildrenUpdate) {
			this.setState({
				categoryStatus: null,
				categoryPreviousStatus: this.state.categoryStatus,
			});
		}
		this.props.response.refetch();
		this.setState({ isCategoryStateFetching: false });
	};

	render() {
		return (
			<UploadCategoryStateContext.Provider
				value={{
					...this.state,
					refetchCategoryState: this.handleRefetch,
				}}
			>
				{this.state.categoryStatus || this.props.response.success
					? this.props.children
					: null}
			</UploadCategoryStateContext.Provider>
		);
	}
}

export const UploadCategoryStateContextProvider = withRouter(
	withData('/category-management-v3/get-category-management-state')(Provider)
);
